import CumulativeServicesComponent from "./cumulative-services";

function CumulativeServices({
  services,
  fromAdmin,
  offer,
  allAnnouncements,
  announcement,
}) {
  return (
    <CumulativeServicesComponent
      correlatedServices={services}
      fromAdmin={fromAdmin}
      offer={offer}
      allAnnouncements={allAnnouncements}
      announcement={announcement}
    />
  );
}

export default CumulativeServices;
